import React from 'react'
import Link from 'gatsby-link'

import logo from '../assets/images/logo.svg'

const IndexPage = () => (
  <div>
    <header
      style={{
        margin: '1em 0',
        height: '99vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <h1>
        We all have a unique talent.<br/> 
        Let's dare use it.
        <img src={ logo } alt="Invet and Thrive"/>
      </h1>
      <h4 style={{ textAlign: 'right' }}>
        ...coming soon
      </h4>
    </header>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js